import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import FavoriteBorderIcon from '@material-symbols/svg-300/rounded/favorite.svg'

import Button from '../../components/basics/Button/Button'
import LearningItemTeaser from '../../components/LearningItemTeaser/LearningItemTeaser'
import Track from '../../components/Track/Track'
import learningSuggestions from '../../state/calculations/learningSuggestions'
import useUserLearningItems from '../../state/queries/useUserLearningItems'
import { useSession } from '../../state/session'
import useFavorites from '../../state/queries/useFavorites'
import useRoutes from '../../state/useRoutes'

import styles from './DashboardPage.module.scss'
import DashboardPageContinueLearning from './DashboardPageContinueLearning'
import DashboardPageSchedule from './DashboardPageSchedule'

export default React.memo(function DashboardPage() {
  const { t } = useTranslation()
  const routes = useRoutes()

  const { user } = useSession()

  const { favorites, hasNextPage: hasMoreFavorites } = useFavorites()

  const { userLearningItems } = useUserLearningItems(user!.uuid)

  const suggestions = useMemo(() => learningSuggestions(userLearningItems), [userLearningItems])

  return (
    <>
      <div className={styles.DashboardPage}>
        <DashboardPageContinueLearning userUuid={user!.uuid} />

        <DashboardPageSchedule userUuid={user!.uuid} />

        <Track
          header={<h1>{t('dashboard.title learning suggestions')}</h1>}
          noItemsHint={t('dashboard.learning suggestions empty')}
        >
          {suggestions.map((learningItem) => (
            <LearningItemTeaser key={learningItem.uuid} showAssigningUser learningItem={learningItem} />
          ))}
        </Track>

        <Track
          className={styles.wishlistheader}
          header={
            <>
              <h1>
                <FavoriteBorderIcon />
                {t('browse courses.wishlist')}
              </h1>
              {hasMoreFavorites && (
                <Button plain component={Link} to={routes.courses.withQuery({ favorites: true }).url({})}>
                  {t('generic cta.show all')}
                </Button>
              )}
            </>
          }
          noItemsHint={t('browse courses.wishlist empty')}
        >
          {favorites.map((learningItem) => (
            <LearningItemTeaser key={learningItem.uuid} learningItem={learningItem} />
          ))}
        </Track>
      </div>
    </>
  )
})

export function DashboardPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.dashboard.url({})}>{t('dashboard.breadcrumb')}</Link>
}
